export const FETCH_ALL_DATA = "plans/fetch-all-data"
export const FETCH_ALL_PLANS = "plans/fetch-all-plans"
export const FETCH_ALL_PLANS_SUCCESS = "plans/fetch-all-plans-success"
export const FETCH_ALL_DATA_SUCCESS = "plans/fetch-all-data-success"
export const FETCH_ALL_DATA_FAILURE = "plans/fetch-all-data-failure"

export const FETCH_CAR_SPECIFICATION = "plans/fetch-car-specification"
export const FETCH_CAR_SPECIFICATION_SUCCESS =
    "plans/fetch-car-specification-success"
export const FETCH_CAR_SPECIFICATION_FAILURE =
    "plans/fetch-car-specification-failure"

export const SET_PLAN_DETAILS = "plans/set_plan_details"
export const FETCH_ALL_POSITION_DATA = "plans/fetch-all-position-data"
export const FETCH_ALL_POSITION_DATA_SUCCESS =
    "plans/fetch-all-position-data-success"
export const FETCH_ALL_POSITION_DATA_FAILURE =
    "plans/fetch-all-position-data-failure"

export const SET_DATA_BY_FIRST_CHAR = "plans/set_data_by_first_char"

export const CLEAR_POSITION_DATA = "plans/clear-position-data"

export const CLEAR_PLAN_DETAILS = "plans/clear-plan-details"

export const ADD_CHIPS = "plans/add_chips"
export const DELETE_CHIPS = "plans/delete_chips"

export const CREATE_NEW_PLAN = "plans/create-new-plan"
export const CREATE_NEW_PLAN_SUCCESS = "plans/create-new-plan-success"
export const CREATE_NEW_PLAN_FAILURE = "plans/create-new-plan-failure"

export const FETCH_PLAN_COPY = "plans/fetch-plan-for-copy"
export const FETCH_PLAN_COPY_SUCCESS = "plans/fetch-plan-for-copy-success"

export const FETCH_PLAN_EDIT = "plans/fetch-plan-for-edit"
export const FETCH_PLAN_EDIT_SUCCESS = "plans/fetch-plan-for-edit-success"
export const UPDATE_PLAN = "plans/update-plan"
export const UPDATE_PLAN_SUCCESS = "plans/update-plan-success"

export const ADD_NEW_PLAN = "plans/add-new-plan"
export const ADD_NEW_PLAN_CANCEL = "plans/add-new-plan-cancel"

export const SET_DEFAULT_PLAN = "plans/set-default-plan"
export const SET_DEFAULT_PLAN_SUCCESS = "plans/set-default-plan-success"

export const DELETE_PLAN = "plans/delete-plan"
export const DELETE_PLAN_SUCCESS = "plans/delete-plan-success"
export const CLEAR_PLANS = "plans/clear-plans"
